<template>
  <div class="insurance-plan-form-container">
    <Panel title="3. แผนประกันภัยและความคุ้มครองที่เลือก">
      <div class="form-group">
        <div class="input-group">
          <span class="input-group-addon nobd-nobg">
            วันที่ต้องการให้เริ่มต้นคุ้มครอง วัน/เดือน/ปี (พ.ศ.)
          </span>
          <DatePicker
            :inputClass="
              `form-control input-sm ${applicationValidationErrors.has('effectiveDate') &&
                'bd-red'}`
            "
            type="effective_date"
            v-model="insurancePlanStartDate"
            :disabled="isDisabledForm"
          />
        </div>
      </div>
      <div class="insurance-plan-information-container clearfix">
        <div class="plan-information col-sm-6">
          <div class="information-label">ชื่อกรมธรรม์ประกันภัย</div>
          <div class="information-description">ttb health care plus</div>
        </div>
        <div class="plan-information col-sm-6">
          <div class="information-label">แผนความคุ้มครอง</div>
          <div class="information-description">
            {{ insuranceInformation.planName }}
          </div>
        </div>
        <div class="plan-information col-sm-6">
          <div class="information-label">ผลประโยชน์เพิ่มเติม</div>
          <div class="information-description">
            {{ formatInsuranceCoverageCode(insuranceInformation.coverageCode) }}
          </div>
        </div>
      </div>

      <div class="insurance-benefit-section">
        <div class="plan-name">
          ความคุ้มครองที่ได้รับ (แผน
          {{ insuranceInformation.planName }})
        </div>

        <!-- TODO Refactor below -->
        <div class="insurance-plan-policy-container">
          <!-- IPD Insurance Plan -->
          <div
            class="ipd-plan-information-container"
            v-if="_.includes(insuranceInformation.coverageCode, packagePlanType.IPD)"
          >
            <div class="plan-header-section">
              <div class="plan-name-information">IPD</div>
              <div class="policy-remark-text">
                ข้อตกลงคุ้มครองการอยู่รักษาตัวในโรงพยาบาลหรือสถานเวชกรรม (ผู้ป่วยใน IPD)
              </div>
            </div>
            <div class="plan-body-section">
              <div
                class="content-section"
                :class="{ 'main-content': !data.sumInsured[insurancePlanId] }"
                v-for="data in _.get(insurancePlanInformationData, 'packageInfo.IPD', [])"
                :key="`IPD#${data.index}`"
              >
                <div class="benefit-description">
                  <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                  <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                  <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                  <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
                </div>
                <div class="benefit-value" v-if="data.sumInsured[insurancePlanId]">
                  {{ data.sumInsured[insurancePlanId] }}
                </div>
              </div>
            </div>
          </div>

          <!-- OPD Insurance Plan -->
          <div
            class="opd-plan-information-container"
            v-if="
              _.includes(insuranceInformation.coverageCode, packagePlanType.OPD_DELUXE) ||
                _.includes(insuranceInformation.coverageCode, packagePlanType.OPD_STANDARD)
            "
          >
            <div class="plan-header-section">
              <div class="plan-name-information">OPD</div>
              <div class="policy-remark-text">
                ข้อตกลงคุ้มครองการรักษาพยาบาลที่ไม่ได้อยู่รักษาตัวในโรงพยาบาลหรือสถานเวชกรรม
                (ผู้ป่วยนอก OPD)
              </div>
            </div>
            <div class="plan-body-section">
              <div
                class="content-section"
                :class="{ 'main-content': !data.sumInsured[insurancePlanId] }"
                v-for="data in _.get(insurancePlanInformationData, 'packageInfo.OPD', [])"
                v-if="_.includes(insuranceInformation.coverageCode, data.value)"
                :key="`OPD#${data.index}`"
              >
                <div class="benefit-description">
                  <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                  <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                  <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                  <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
                </div>
                <div class="benefit-value" v-if="data.sumInsured[insurancePlanId]">
                  {{ data.sumInsured[insurancePlanId] }}
                </div>
              </div>
            </div>
          </div>

          <!-- HIB Insurance Plan -->
          <div
            class="hib-plan-information-container"
            v-if="_.includes(insuranceInformation.coverageCode, packagePlanType.HIB)"
          >
            <div class="plan-header-section">
              <div class="plan-name-information">HIB</div>
              <div class="policy-remark-text">
                เงินชดเชยรายได้รายวันระหว่างรักษาตัวในโรงพยาบาล (HIB)
              </div>
            </div>
            <div class="plan-body-section">
              <div
                class="content-section"
                :class="{ 'main-content': !data.sumInsured[insurancePlanId] }"
                v-for="data in _.get(insurancePlanInformationData, 'packageInfo.HIB', [])"
                :key="`HIB#${data.index}`"
              >
                <div class="benefit-description">
                  <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                  <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                  <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                  <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
                </div>
                <div class="benefit-value" v-if="data.sumInsured[insurancePlanId]">
                  {{ data.sumInsured[insurancePlanId] }}
                </div>
              </div>
            </div>
          </div>

          <!-- Cancer Insurance Plan -->
          <div
            class="cancer-plan-information-container"
            v-if="_.includes(insuranceInformation.coverageCode, packagePlanType.CANCER)"
          >
            <div class="plan-header-section">
              <div class="plan-name-information">Cancer</div>
              <div class="policy-remark-text">
                การประกันภัยโรคมะเร็ง (CANCER)
              </div>
            </div>
            <div class="plan-body-section">
              <div
                class="content-section"
                :class="{ 'main-content': !data.sumInsured[insurancePlanId] }"
                v-for="data in _.get(insurancePlanInformationData, 'packageInfo.CANCER', [])"
                :key="`CANCER#${data.index}`"
              >
                <div class="benefit-description">
                  <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                  <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                  <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                  <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
                </div>
                <div class="benefit-value" v-if="data.sumInsured[insurancePlanId]">
                  {{ data.sumInsured[insurancePlanId] }}
                </div>
              </div>
            </div>
          </div>

          <!-- CI Insurance Plan -->
          <div
            class="ci-plan-information-container"
            v-if="_.includes(insuranceInformation.coverageCode, packagePlanType.CI)"
          >
            <div class="plan-header-section">
              <div class="plan-name-information">Critical Illness</div>
              <div class="policy-remark-text">
                การประกันภัยโรคร้ายแรง (CI)
              </div>
            </div>
            <div class="plan-body-section">
              <div
                class="content-section"
                :class="{ 'main-content': !data.sumInsured[insurancePlanId] }"
                v-for="data in _.get(
                  insurancePlanInformationData,
                  'packageInfo[CRITICAL ILLNESS]',
                  [],
                )"
                :key="`CI#${data.index}`"
              >
                <div class="benefit-description">
                  <span v-if="data.coverageNameTh">{{ data.coverageNameTh }} </span>
                  <span v-if="data.coverageNameEn">{{ data.coverageNameEn }} </span>
                  <span v-if="data.coverageConditionTh">{{ data.coverageConditionTh }} </span>
                  <span v-if="data.coverageConditionEn">{{ data.coverageConditionEn }} </span>
                </div>
                <div class="benefit-value" v-if="data.sumInsured[insurancePlanId]">
                  {{ data.sumInsured[insurancePlanId] }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="summary-information-container">
        <div class="plan-price-section summary-section">
          <div class="description">
            - ค่าเบี้ยสุทธิ ({{ formatInsuranceCoverageCode(insuranceInformation.coverageCode) }})
          </div>
          <div class="amount">
            {{ insuranceInformation.totalBeforeDeduct | formatNumber }}
            บาท
          </div>
        </div>
        <div class="deductible-section summary-section">
          <div class="description">
            - ส่วนลดเบี้ยประกันภัยสำหรับการติดเงื่อนไขความรับผิดส่วนแรก (Deductible-DD)
            สำหรับค่าห้องและค่ารักษาพยาบาลผู้ป่วยใน (DD{{
              insuranceInformation.deductible.value | formatNumber
            }})
          </div>
          <div class="amount">
            {{ insuranceInformation.deductible.discount | formatNumber }}
            บาท
          </div>
        </div>
        <div class="family-discount-section summary-section" v-if="typeInsurance === 'family'">
          <div class="description">
            - ส่วนลดเบี้ยประกันภัยสำหรับครอบครัว (ได้รับส่วนลด
            {{ insuranceInformation.familyDiscount.percentage }}%)
            <i
              class="fas fa-info-circle info-icon"
              @click="isShowDiscountInfo = !isShowDiscountInfo"
            >
              <div class="discount-information-section" v-if="isShowDiscountInfo">
                (ค่าเบี้ยสุทธิ - ส่วนลด DD) x ส่วนลดสำหรับครอบครัว
              </div>
            </i>
          </div>
          <div class="amount">
            {{ insuranceInformation.familyDiscount.discount | formatNumber }}
            บาท
          </div>
        </div>
        <div class="total-price-section summary-section">
          <div class="description">รวมเบี้ยประกันภัยที่ต้องชำระ</div>
          <div class="amount">
            {{ insuranceInformation.finalTotal | formatNumber }}
            บาท
          </div>
        </div>
      </div>
    </Panel>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapActions, mapGetters } from 'vuex'
import { createHelpers } from 'vuex-map-fields'
import { Validator } from 'vee-validate'
import moment from 'moment'

import DatePicker from '@/components/DatePicker'
import Panel from '@/components/Panel'
import { packagePlanType } from '@/lib/global'
import { formatInsuranceCoverageCode } from '@/lib/services'

const { mapFields: mapApplicationFields } = createHelpers({
  getterType: 'getApplicationFields',
  mutationType: 'updateApplicationFields',
})

export default {
  name: 'InsurancePlanForm',
  props: ['typeInsurance'],
  data: () => ({
    packagePlanType,
    isShowDiscountInfo: false,
  }),
  computed: {
    ...mapGetters(['insurancePlanInformationData', 'applicationValidationErrors']),
    ...mapGetters({
      isDisabledForm: 'isDisabledApplicationForm',
    }),
    ...mapApplicationFields({
      insurancePlanStartDate: 'data.insurancePlanStartDate',
      insuranceInformation: 'data.insuranceInformation',
      insurancePlanId: 'data.insuranceInformation.planId',
    }),
  },
  components: {
    DatePicker,
    Panel,
  },
  methods: {
    formatInsuranceCoverageCode,
  },
}
</script>

<style lang="scss">
.insurance-plan-form-container {
  .start-date-input {
    border: 1px solid #ccc;
    width: 100%;
  }

  .insurance-plan-information-container {
    border-bottom: 1px dashed #ccc;
    margin-bottom: 24px;
    padding-bottom: 24px;

    .plan-information {
      .information-label,
      .information-description {
        display: inline-block;
        font-size: 14px;
        line-height: 18px;
        margin-bottom: 12px;
      }

      .information-label {
        color: #000000;
        margin-right: 8px;
      }

      .information-description {
        color: #00a350;
      }
    }
  }

  .insurance-benefit-section {
    border-bottom: 1px dashed #ccc;
    margin-bottom: 24px;
    padding: 0 15px 32px;

    .plan-name {
      margin-bottom: 16px;
    }

    .insurance-plan-policy-container {
      margin-left: -30px;
      margin-right: -30px;

      .ipd-plan-information-container {
        .plan-header-section {
          background-color: #00a350;
        }

        .plan-body-section {
          counter-reset: benefit-counter;

          .content-section {
            &:not(:first-child) {
              &:not(.main-content) {
                .benefit-description::before {
                  content: '- ';
                }
              }
            }

            &.main-content {
              .benefit-description::before {
                content: counter(benefit-counter) '. ';
                counter-increment: benefit-counter;
              }
            }
          }
        }
      }

      .opd-plan-information-container {
        .plan-header-section {
          background-color: #4b775c;
        }
      }

      .hib-plan-information-container {
        .plan-header-section {
          background-color: #3f74b0;
        }
      }

      .cancer-plan-information-container {
        .plan-header-section {
          background-color: #727072;
        }
      }

      .ci-plan-information-container {
        .plan-header-section {
          background-color: #cbab42;
        }
      }

      .plan-header-section {
        color: #fff;
        padding: 12px;

        .plan-name-information {
          font-size: 18px;
          line-height: 22px;
          margin-bottom: 4px;
        }

        .policy-remark-text {
          font-size: 14px;
          line-height: 18px;
        }
      }

      .plan-body-section {
        .content-section {
          border-bottom: 1px solid #dddddd;

          &:not(.main-content) {
            display: grid;
            grid-template-columns: 1fr 186px;
          }

          &.main-content {
            background-color: #dddddd;
          }

          .benefit-description {
            padding: 12px 6px 12px 12px;
            white-space: pre-line;
          }

          .benefit-value {
            align-items: center;
            background-color: #c4c4c4;
            display: flex;
            justify-content: center;
          }
        }
      }
    }
  }

  .summary-information-container {
    padding: 0 15px;

    .summary-section {
      display: grid;
      grid-template-columns: 4fr 1fr;
      grid-gap: 32px;
      margin-bottom: 12px;

      .description {
        color: #000000;
        font-size: 14px;
        line-height: 18px;
      }

      .amount {
        color: #000000;
        font-family: 'psl_kanda_extraregular';
        font-size: 14px;
        line-height: 18px;
        text-align: right;
      }
    }

    .total-price-section {
      .description {
        font-family: 'psl_kanda_extraregular';
        font-size: 18px;
        line-height: 22px;
      }

      .amount {
        color: #00a350;
        font-size: 18px;
        line-height: 22px;
      }
    }
  }

  .info-icon {
    cursor: pointer;
    position: relative;

    .discount-information-section {
      background-color: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 3px;
      box-shadow: 0 4px 20px 0 rgba(52, 73, 94, 0.2);
      font-family: 'psl_kandaboldSVG', 'psl_kandabold';
      font-size: 12px;
      line-height: 16px;
      padding: 12px;
      position: absolute;
      bottom: 30px;
      left: -23px;
      width: 180px;

      &:before {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #fff;
        content: '';
        display: block;
        filter: drop-shadow(0 2px 2px rgba(52, 73, 94, 0.1));
        position: absolute;
        bottom: -10px;
        left: 20px;
        width: 0;
        height: 0;
      }
    }
  }
}
</style>
